module.exports = __webpack_public_path__ + "files/5c3aacd55c2a7d55f09c71f7fdefbd73.svg";